import { CardImage } from "@ecliptica/game-ui";
import { useTranslation, type Lang } from "@ecliptica/i18n";
import { Button } from "@ecliptica/ui";
import { Link } from "react-router";
import { FEATURED_CARDS } from "../../content/featured";
import { sitePath } from "../../lib/lang";
import { Section } from "./Section";

/** Faixa curta da página inicial: algumas cartas em destaque e a ligação para a galeria completa (/cards). */
export function CardsStrip({ lang }: { lang: Lang }) {
  const { t } = useTranslation();
  return (
    <Section id="cards" title={t("cards.title")} lead={t("cards.lead")} bg="/bg/collection.webp">
      <ul className="mx-auto flex max-w-[1200px] list-none justify-start gap-3 lg:justify-center overflow-x-auto p-0 pb-2 sm:gap-5">
        {FEATURED_CARDS.map((c) => (
          <li key={c.id} className="w-[38vw] max-w-[220px] shrink-0">
            <Link to={sitePath(lang, "cards")} tabIndex={-1} aria-hidden>
              <CardImage id={c.id} lang={lang} alt={c.name[lang]} width={300} height={420} className="transition-transform hover:-translate-y-1" />
            </Link>
          </li>
        ))}
      </ul>
      <div className="mt-8 text-center">
        <Button asChild variant="primary" size="lg">
          <Link to={sitePath(lang, "cards")}>{t("cards.seeAll")}</Link>
        </Button>
      </div>
    </Section>
  );
}
